module.exports = __webpack_public_path__ + "img/1676593760027-Screenshot_2023-02-17-08-28-41-78_1c337646f29875672b5a61192b9010f9.jpg.f0e46bc4.webp";